import React, { Component } from "react";
import PropTypes from "prop-types";

class View extends Component {
  static propTypes = {
    style: PropTypes.object,
    children: PropTypes.any,
  };

  render() {
    const { style: styleProps, ...rest } = this.props;
    const styles = { ...defaultStyle, ...styleProps };
    return (
      <div style={styles} {...rest}>
        {this.props.children}
      </div>
    );
  }
}

const defaultStyle = {
  display: "flex",
  flexDirection: "column",
};

export default View;
